module.exports = __webpack_public_path__ + "static/media/LV_Block.688a641a.jpg";